<script setup lang="ts">
import { computed, type HTMLAttributes, ref, watch } from 'vue'

import { TablePaginationButtons } from '.'
import TablePageSizeSelect from './TablePageSizeSelect.vue'

export type TablePaginationProperties = {
  class?: HTMLAttributes['class']
  /**
   * The number of items per page
   */
  size: number
  /**
   * Whether the user can change the number of items per page
   */
  sizeable?: boolean
  /**
   * The total number of items
   */
  total: number
}
export interface TablePaginationEmits {
  (event: 'update:size', size: number): void
  (event: 'update:page', size: number): void
}

defineOptions({ inheritAttrs: true })
const emit = defineEmits<TablePaginationEmits>()
const properties = withDefaults(defineProps<TablePaginationProperties>(), {
  class: '',
  sizeable: true,
})

const page = defineModel<number>('page', { required: true })
const pageSize = ref<string>(String(properties.size))

watch(
  () => properties.size,
  (value) => {
    pageSize.value = String(value)
  },
)

function onChangePageSize(size: number) {
  emit('update:size', size)
  emit('update:page', 1)
}

function onChangePageCurrent(page: number) {
  emit('update:page', page)
}

function getPageCountForSize(size: number, total: number): number {
  return Math.max(1, Math.ceil(total / size))
}

const pageCount = computed(() => getPageCountForSize(Number(properties.size), properties.total))
</script>

<template>
  <div :class="['atabix-pagination', properties.class]">
    <TablePageSizeSelect v-if="sizeable" class="atabix-pagination__limit" :size="size" @change="onChangePageSize" />
    <TablePaginationButtons :page="page" :page-count="pageCount" size="sm" @change="onChangePageCurrent" />
  </div>
</template>

<style lang="scss">
.atabix-pagination {
  @apply flex flex-row items-center justify-between gap-12 p-4;
}

.atabix-pagination__limit,
.atabix-pagination__controls {
  @apply flex flex-row items-center;
  @apply gap-4;
}

.atabix-pagination__limit {
}

.atabix-pagination__controls {
  .atabix-button-group {
    @apply gap-2;
  }
}
</style>
